if ('IntersectionObserver' in window) {
  const classBase = 'js-band__scrolldown';

  const callback = (entries, observer) => {
    entries.forEach((entry) => {
      entry.target.classList.toggle(classBase + '--down', entry.isIntersecting);
    });
  };

  const options = {
    rootMargin: '20% 0% -20% 0%',
  };

  const observer = new IntersectionObserver(callback, options);

  document.querySelectorAll('.' + classBase)
      .forEach((target) => observer.observe(target));
}
